export const siteInfo = {
  name: "瓜田吃瓜",
  slogan: "围观现场，瓜田不迷路",
  tagline: "吃瓜群众集合地 · 蹲后续 · 看反转 · 追实锤",
  email: "guatian@example.com",
  since: "2023",
  intro:
    "瓜田吃瓜是一个专注公开信息梳理的吃瓜资讯站。我们把娱乐圈八卦、影视综艺、社会热点、音乐潮流等方向的公开报道、当事人回应和后续进展集中整理，按时间线呈现，让每一次围观都有据可查。",
};

export const siteStats = [
  { id: "stat-1", label: "今日新瓜", value: "48", unit: "条" },
  { id: "stat-2", label: "蹲后续用户", value: "12.6", unit: "万" },
  { id: "stat-3", label: "更新中的时间线", value: "76", unit: "条" },
  { id: "stat-4", label: "本月围观人次", value: "930", unit: "万" },
];

export const categories = [
  {
    id: "yule",
    name: "娱乐八卦",
    icon: "ri-user-star-line",
    desc: "明星动态、人设反转与圈内动向的围观现场",
    count: 128,
  },
  {
    id: "yingshi",
    name: "影视综艺",
    icon: "ri-movie-2-line",
    desc: "剧集、综艺与片场花絮里被忽略的细节",
    count: 96,
  },
  {
    id: "shehui",
    name: "社会热点",
    icon: "ri-fire-line",
    desc: "全网关注的社会事件与必须跟进的后续",
    count: 74,
  },
  {
    id: "yinyue",
    name: "音乐潮流",
    icon: "ri-music-2-line",
    desc: "演唱会、新歌发布与潮流圈的实时动态",
    count: 52,
  },
  {
    id: "wanghong",
    name: "网红直播",
    icon: "ri-live-line",
    desc: "直播间名场面、达人社群与供应链风波",
    count: 63,
  },
  {
    id: "tiyu",
    name: "体育赛场",
    icon: "ri-basketball-line",
    desc: "赛场内外的名场面与选手的真实故事",
    count: 41,
  },
  {
    id: "keji",
    name: "科技数码",
    icon: "ri-smartphone-line",
    desc: "新品发布、行业风向与数码圈的趣闻",
    count: 35,
  },
  {
    id: "shenghuo",
    name: "生活百态",
    icon: "ri-plant-line",
    desc: "身边小事里的大讨论与温暖瞬间",
    count: 88,
  },
];

export const hotSearches = [
  { id: "hot-1", rank: 1, title: "某剧组深夜改剧本疑云", tag: "爆", scopeHint: "影视综艺" },
  { id: "hot-2", rank: 2, title: "顶流音乐节现场返图刷屏", tag: "热", scopeHint: "音乐潮流" },
  { id: "hot-3", rank: 3, title: "老牌综艺官宣回归阵容", tag: "热", scopeHint: "影视综艺" },
  { id: "hot-4", rank: 4, title: "直播间秒空补货三连", tag: "新", scopeHint: "网红直播" },
  { id: "hot-5", rank: 5, title: "新片预告片彩蛋逐帧解析", tag: "新", scopeHint: "影视综艺" },
  { id: "hot-6", rank: 6, title: "选手赛后采访名场面", tag: "", scopeHint: "体育赛场" },
  { id: "hot-7", rank: 7, title: "数码新品发布会看点盘点", tag: "", scopeHint: "科技数码" },
  { id: "hot-8", rank: 8, title: "城市夜市爆火打卡地", tag: "", scopeHint: "社会热点" },
];

export const melons = [
  {
    id: "juzu-gajuben",
    title: "剧组深夜改剧本疑云：三位主演同框消失的背后",
    categoryId: "yingshi",
    categoryName: "影视综艺",
    author: "瓜田小喇叭",
    date: "2026-09-08",
    readTime: "6 分钟",
    heat: "爆",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20glowing%20theater%20stage%20with%20deep%20velvet%20curtains%20and%20a%20single%20warm%20spotlight%2C%20rich%20amber%20and%20crimson%20tones%2C%20minimalist%20magazine%20style%2C%20soft%20gradients%2C%20clean%20uncluttered%20background%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-01&orientation=landscape",
    coverAlt: "舞台与幕布插画，指代影视剧组围观的娱乐八卦场景",
    summary:
      "一条深夜改动的通告单，让原本平静的剧组瞬间被推上风口。我们按时间顺序把公开信息串了一遍，看看哪些是实锤，哪些还只是猜测。",
    highlight: "反转之前，先把时间线捋顺，比急着站队更有用。",
    tags: ["剧组", "改剧本", "影视围观", "时间线"],
    content: [
      "最先引起讨论的，是一份被网友截图分享的拍摄通告单。截图显示，原定于次日清晨开拍的戏份在深夜被临时调整，涉及三位主要演员。由于改动发生得过于突然，评论区很快出现了各种猜测。",
      "需要说明的是，通告单调整在剧组里并不罕见。天气、场地租期、演员档期，任何一个环节出问题都可能引发连锁调整。因此单纯凭一份通告单就断言内部失和，显然是不够严谨的。",
      "真正让话题升温的，是随后出现的第二条线索。有现场工作人员发布了收工照片，照片中的时间与通告单上的调整时间存在出入。这个细节被反复放大，成为双方争论的焦点。",
      "截至目前，剧组官方账号并未就具体原因作出说明，只表示一切以正式通告为准。我们梳理了从爆料出现到官方回应的完整顺序，并把无法核实的部分单独标注，方便大家自行判断。",
      "按照过去的经验，这类事件通常会有三种走向：一是很快有官方说明，二是被新的热点覆盖，三是在后续物料中悄悄给出答案。无论哪一种，蹲后续的意义就在于不提前下结论。",
    ],
  },
  {
    id: "yinyuejie-fantu",
    title: "音乐节现场返图刷屏，舞台背后的三小时发生了什么",
    categoryId: "yinyue",
    categoryName: "音乐潮流",
    author: "前排围观官",
    date: "2026-09-07",
    readTime: "5 分钟",
    heat: "热",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20music%20festival%20stage%20with%20speaker%20stacks%20and%20glowing%20warm%20light%20beams%2C%20golden%20amber%20and%20green%20tones%2C%20minimalist%20modern%20poster%20style%2C%20soft%20grain%20texture%2C%20clean%20background%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-02&orientation=landscape",
    coverAlt: "音乐节舞台插画，指代演唱会与音乐潮流话题",
    summary:
      "返图刷屏的同一晚，现场观众和线上观众的体验却出现了明显分叉。我们把舞台调度、天气和转播信号三条线索拼在一起看。",
    highlight: "同一场演出，看台与屏幕之间隔着一整套流程。",
    tags: ["音乐节", "演唱会", "现场返图"],
    content: [
      "演出结束不到半小时，社交平台就被现场返图占满。舞台灯光、观众应援和票面设计成为讨论重点，但很快也有人提出，线上直播看到的画面与现场观感并不一致。",
      "差异的第一来源是舞台调度。为了让后排观众也能看清，主办方通常会把主舞台元素做得更高更亮，这会让镜头里的比例与肉眼观感产生出入。这属于正常的设计取舍，并非意外。",
      "第二个变量是天气。当晚出现短时阵风，舞台侧屏一度降低亮度以保证安全。现场观众能看到工作人员在侧台快速沟通，而直播画面里这部分被自然切掉了。",
      "第三是转播信号。大型演出的导播需要同时处理多路机位，任何一次切换都会改变观众的注意力落点。所以线上觉得气氛没到顶点，现场可能恰恰相反。",
      "把这些线索放在一起，返图刷屏就不再只是审美问题，而是一次关于观看方式的讨论。下一次再遇到类似争议，不妨先问问自己看的是哪一路画面。",
    ],
  },
  {
    id: "zongyi-huigui",
    title: "老牌综艺官宣回归：嘉宾名单里的新老交替信号",
    categoryId: "yingshi",
    categoryName: "影视综艺",
    author: "蹲后续的阿糖",
    date: "2026-09-06",
    readTime: "4 分钟",
    heat: "热",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20retro%20television%20studio%20with%20vintage%20cameras%20and%20warm%20studio%20lights%2C%20soft%20cream%20and%20amber%20palette%2C%20minimalist%20magazine%20style%2C%20smooth%20gradients%2C%20clean%20background%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-03&orientation=landscape",
    coverAlt: "复古演播厅插画，指代老牌综艺节目回归话题",
    summary:
      "一档陪伴观众多年的综艺宣布回归。比起节目本身，嘉宾名单的变化更值得细看，它往往透露着节目组的真实意图。",
    highlight: "名单从来不是随便排的，位置顺序就是态度。",
    tags: ["综艺", "回归", "嘉宾阵容"],
    content: [
      "官宣海报发布后，最先被讨论的不是播出时间，而是嘉宾的排列顺序。在这类海报里，排位往往暗示着镜头比重与叙事重心，观众对此早已形成默契。",
      "看名单结构可以分成三层：稳定阵容负责托底，新面孔负责制造新鲜感，飞行嘉宾负责话题热度。三层比例的变化，直接决定了节目气质会往哪个方向走。",
      "这次比较明显的变化是，新面孔占比上升。这通常意味着节目希望拉近与年轻观众的距离，同时也在为更长的制作周期做储备。",
      "值得注意的是，老成员的镜头并不一定会减少。经验丰富的成员往往是节目的节奏控制者，减少他们反而会让新环节显得松散。",
      "所以与其纠结谁站在中间，不如关注首期播出后的剪辑重心。那才是真正能看出节目意图的地方，也是我们接下来要蹲的后续。",
    ],
  },
  {
    id: "zhibojian-miaokong",
    title: "直播间秒空补货三连，供应链团队连夜开会的真相",
    categoryId: "wanghong",
    categoryName: "网红直播",
    author: "瓜藤记录员",
    date: "2026-09-05",
    readTime: "5 分钟",
    heat: "新",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20modern%20livestream%20setup%20with%20a%20ring%20light%2C%20microphone%20and%20shipping%20boxes%2C%20warm%20coral%20and%20cream%20tones%2C%20minimalist%20flat%20design%2C%20soft%20shadows%2C%20clean%20background%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-04&orientation=landscape",
    coverAlt: "直播间设备插画，指代网红直播与带货话题",
    summary:
      "一场直播连续三次秒空，评论区一半在夸一半在质疑。我们把库存逻辑和备货节奏摊开讲，看看秒空到底是实力还是话术。",
    highlight: "秒空可以设计，但补货速度骗不了人。",
    tags: ["直播带货", "库存", "供应链"],
    content: [
      "直播带货里，秒空是一种强刺激。屏幕上库存数字快速归零，会让观望的观众产生紧迫感。但秒空本身并不能直接说明销量规模，因为它的起点是上架库存。",
      "判断一场直播是否真实火爆，可以看补货节奏。真正的热销品，补货需要工厂排产、物流揽收和仓内分拣，短时间内很难连续大额补充。",
      "这次事件里，主播在四十分钟内三次补货，且每次都维持了较长时间才售罄。这说明后端有比较扎实的备货盘，而不是临时加塞。",
      "另一条线索是退款率。火爆之后的退款数据通常在几天后才会显现，它比实时销量更能反映真实的满意程度。",
      "所以现在下结论还太早。我们会在退款数据公布后补上这一段，把这条时间线补完整。",
    ],
  },
  {
    id: "yupian-caidan",
    title: "新片预告片逐帧解析：那些被忽略的彩蛋线索",
    categoryId: "yingshi",
    categoryName: "影视综艺",
    author: "瓜田小喇叭",
    date: "2026-09-04",
    readTime: "7 分钟",
    heat: "新",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20film%20reel%20and%20strip%20of%20movie%20frames%20floating%20over%20a%20warm%20beige%20surface%2C%20amber%20and%20deep%20green%20accents%2C%20minimalist%20magazine%20style%2C%20soft%20gradients%2C%20clean%20background%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-05&orientation=landscape",
    coverAlt: "电影胶片插画，指代新片预告片与彩蛋解析话题",
    summary:
      "两分半的预告片里，藏着至少五处可以确认的细节。我们一帧一帧看过去，把能站得住脚的线索挑出来，顺手排除掉几个流传较广的误读。",
    highlight: "彩蛋的价值在于能被验证，而不是讲得越玄越好。",
    tags: ["预告片", "彩蛋", "电影"],
    content: [
      "解析预告片最容易犯的错误，是把剪辑顺序当成剧情顺序。预告片的镜头是重新排列的，相邻两帧在正片里可能相隔很远。",
      "第一处可以确认的线索出现在第 38 秒。背景里闪过一块牌子，文字方向与预告片其他画面相反，这通常是刻意留下的提示。",
      "第二处是配乐。前段使用的主题旋律在结尾被降调处理，这是影视配乐里表达情绪转向的常见手法，往往对应剧情的转折点。",
      "至于网上流传最广的那个说法，我们把原始画面放大后并没有找到对应细节，因此暂时不建议当真。",
      "预告片只是入口，真正的答案要等正片。后续如果有新的物料发布，我们会继续更新这份清单。",
    ],
  },
  {
    id: "xuanshou-caifang",
    title: "选手赛后采访名场面：一句玩笑如何冲上热搜",
    categoryId: "tiyu",
    categoryName: "体育赛场",
    author: "前排围观官",
    date: "2026-09-03",
    readTime: "4 分钟",
    heat: "",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20empty%20stadium%20arena%20at%20dusk%20with%20floodlights%20and%20green%20turf%2C%20emerald%20and%20amber%20tones%2C%20minimalist%20sports%20poster%20style%2C%20soft%20grain%2C%20clean%20background%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-06&orientation=landscape",
    coverAlt: "体育场看台插画，指代体育赛场与选手采访话题",
    summary:
      "比赛结束后的采访区，一句话在半小时内完成了从现场到热搜的传播。我们复盘了这段传播链路，也顺便聊聊运动员的表达边界。",
    highlight: "赛后的三十秒，往往比整场比赛更考验人。",
    tags: ["赛后采访", "运动员", "传播"],
    content: [
      "采访区的传播速度往往超出想象。记者提问、选手作答、现场收音，这三步几乎同时发生，任何一句即兴表达都可能在几分钟内被截取传播。",
      "这次的走红点在于语气。相同的文字，用轻松的语气说出来就是玩笑，用严肃的语气说出来就完全不同。传播过程中，语气恰恰是最容易丢失的信息。",
      "从传播链路看，先是现场观众拍下短视频，随后被体育账号转发，最后进入综合热搜。每一环都在削减上下文，这也是误读产生的土壤。",
      "事实上，运动员赛后接受采访的时间通常很有限，情绪也处在高点。理解这一点，再回看那句话，感受会不一样。",
      "赛事方目前没有进一步表态，选手本人也未再回应。我们倾向于把它当作一次传播案例来看，而不是一次争议事件。",
    ],
  },
  {
    id: "shuma-fabu",
    title: "数码新品发布会看点盘点：参数之外的体验之争",
    categoryId: "keji",
    categoryName: "科技数码",
    author: "瓜藤记录员",
    date: "2026-09-02",
    readTime: "6 分钟",
    heat: "",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20minimal%20consumer%20electronics%20gadgets%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20geometric%20shapes%2C%20amber%20and%20sage%20green%20palette%2C%20minimalist%20product%20photography%20style%2C%20clean%20background%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-07&orientation=landscape",
    coverAlt: "数码产品插画，指代科技新品发布与体验讨论话题",
    summary:
      "发布会看完，参数表也刷了一遍。但真正决定日常体验的，往往不是那几个最显眼的数字，而是藏在细节里的取舍。",
    highlight: "参数决定下限，调校决定上限。",
    tags: ["新品发布", "数码", "体验"],
    content: [
      "发布会的时间分配本身就透露着重点。一款产品讲解时间越长，通常意味着它承载了更多销量期待，也意味着这一代的主要卖点在哪里。",
      "参数表里最容易被忽略的是功耗与散热。它们不会出现在第一页，却直接决定长时间使用时的稳定性。",
      "另一个值得关注的是系统更新承诺。硬件生命周期再长，如果软件支持跟不上，体验依然会快速下滑。",
      "从现场演示来看，这次把较多篇幅放在了跨设备协同上，说明厂商希望把用户留在自己的生态里，而不只是卖出一台设备。",
      "真正的评价要等实机上手。我们会在首批真实体验数据出来后，补上这份盘点里最缺的那一块。",
    ],
  },
  {
    id: "yeshi-daka",
    title: "城市夜市爆火打卡地：摊主们没想到的一周",
    categoryId: "shehui",
    categoryName: "社会热点",
    author: "蹲后续的阿糖",
    date: "2026-09-01",
    readTime: "5 分钟",
    heat: "",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20warm%20cozy%20night%20market%20street%20with%20glowing%20lanterns%20and%20food%20stalls%2C%20amber%20and%20coral%20glow%2C%20minimalist%20illustration%20poster%20style%2C%20soft%20gradients%2C%20clean%20composition%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=1200&height=800&seq=gt-melon-08&orientation=landscape",
    coverAlt: "夜市街道插画，指代城市夜市爆火与生活热点话题",
    summary:
      "一条短视频让夜市客流翻了几倍。热闹背后，摊主、居民和管理方各自迎来了完全不同的挑战，这才是值得跟进的后续。",
    highlight: "流量来得快，配套得跟上，这才是真正的考题。",
    tags: ["夜市", "城市生活", "热点追踪"],
    content: [
      "视频爆火后的第一个周末，夜市入口排起了长队。对摊主而言，这是意料之外的收入高峰；对周边居民而言，却是突如其来的噪音与拥堵。",
      "摊主们的应对各不相同。有人临时增加了备货和人手，有人选择限量出售以维持出品质量。短期看前者收入更高，长期看后者口碑更稳。",
      "居民最关心的是秩序。垃圾清运、停车引导和噪音控制，任何一项跟不上，热情就会迅速转为反感。这也是很多网红街区昙花一现的原因。",
      "管理方的动作相对克制，主要是在高峰时段加派人手，并尝试用单向动线疏导客流。这种做法看起来不显眼，但往往最有效。",
      "热度会回落，这是规律。真正决定这个夜市能不能长期走下去的，是接下来几周能不能把临时措施沉淀成常态。我们会继续跟。",
    ],
  },
];

export const timelineUpdates = [
  {
    id: "tl-1",
    time: "09:12",
    title: "官方账号悄悄调整置顶",
    text: "剧组官方账号修改了置顶动态，评论区迅速被问号刷屏，但官方暂未补充说明。",
    status: "已确认",
  },
  {
    id: "tl-2",
    time: "11:40",
    title: "工作人员晒出收工照",
    text: "有现场工作人员发布凌晨收工照片，时间线与此前流传的说法出现明显出入。",
    status: "已确认",
  },
  {
    id: "tl-3",
    time: "14:05",
    title: "平台方回应以通告为准",
    text: "相关平台方回应称一切以正式通告为准，热搜位次在当天持续波动。",
    status: "已回应",
  },
  {
    id: "tl-4",
    time: "18:30",
    title: "场记记录流出",
    text: "有数据账号放出更完整的场记记录，反转苗头出现，讨论重心从猜疑转向核对。",
    status: "待核实",
  },
  {
    id: "tl-5",
    time: "21:15",
    title: "当事人轻描淡写回应",
    text: "当事人在直播中用一句玩笑话带过，话题热度回落，这一轮瓜基本落地。",
    status: "已确认",
  },
];

export const faqs = [
  {
    id: "faq-1",
    q: "瓜田吃瓜主要更新哪些内容？",
    a: "我们围绕娱乐圈八卦、影视综艺、社会热点、音乐潮流、网红直播等方向，第一时间整理围观现场的公开信息。每条内容都会标注信息来源与更新时间，方便你自行判断。",
  },
  {
    id: "faq-2",
    q: "网站上的信息可靠吗？",
    a: "我们只搬运和梳理公开报道、官方通告以及当事人的公开回应，不做无依据的推断。对于尚未证实的部分，我们会单独标注为待核实，绝不混在结论里。",
  },
  {
    id: "faq-3",
    q: "怎样才能第一时间蹲到后续？",
    a: "在页面底部填写邮箱订阅蹲后续提醒即可。当一条时间线出现新的进展时，我们会在整理完成后优先通知订阅用户。",
  },
  {
    id: "faq-4",
    q: "我可以投稿或者提供线索吗？",
    a: "欢迎。通过页面底部公示的邮箱联系我们，请在邮件中尽量附上可核实的公开链接与大致时间，我们会安排核对后决定是否跟进。",
  },
  {
    id: "faq-5",
    q: "浏览和订阅需要付费吗？",
    a: "完全免费。我们不售卖会员，也不在正文中插入付费墙。如果你看到任何要求付费解锁后续的说法，那都不是我们。",
  },
];

export const testimonials = [
  {
    id: "tm-1",
    name: "小满",
    role: "三年老吃瓜人",
    quote: "最喜欢的是一点一点补全的时间线，不用再翻十几个帖子拼碎片，蹲后续真的省心。",
  },
  {
    id: "tm-2",
    name: "阿哲",
    role: "前排围观常客",
    quote: "标注待核实这点特别加分。看多了就知道，敢承认不确定的账号才值得长期关注。",
  },
  {
    id: "tm-3",
    name: "栗子同学",
    role: "内容爱好者",
    quote: "排版清爽，手机上刷起来一点都不累，通勤路上十分钟就能把当天的瓜看明白。",
  },
  {
    id: "tm-4",
    name: "老周",
    role: "影视从业者",
    quote: "从行业角度看，他们的描述比很多账号克制，愿意区分流程问题和人事问题，这点很难得。",
  },
];

export const contentPrinciples = [
  {
    id: "cp-1",
    icon: "ri-shield-check-line",
    title: "只做公开信息梳理",
    text: "所有内容来自公开报道、官方通告与当事人公开回应，不采用来源不明的私信内容。",
  },
  {
    id: "cp-2",
    icon: "ri-time-line",
    title: "用时间线说话",
    text: "把事件按发生顺序排列，标注每一步的确认状态，让反转有迹可循，而不是被情绪牵着走。",
  },
  {
    id: "cp-3",
    icon: "ri-scales-3-line",
    title: "区分事实与猜测",
    text: "已确认、已回应、待核实三种状态明确分开，绝不把推测包装成结论。",
  },
  {
    id: "cp-4",
    icon: "ri-heart-3-line",
    title: "保持基本善意",
    text: "围观不等于审判，讨论公众事件时不消费个人隐私，不参与人身攻击式的站队。",
  },
];